import React from 'react';

const IconArrowRight = () => (
  <svg width="42" height="25" viewBox="0 0 42 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27.9177 23.5993L28.7564 24.5L42 12.25L28.7564 0L27.9177 0.900658L39.5233 11.6356H0V12.8648H39.5233L27.9177 23.5993Z" fill="currentColor" />
  </svg>
);

export default IconArrowRight;
